import { gql } from "@apollo/client";
import React from "react";
import { useSensorFirmwareNamesQuery } from "./SensorFirmwareSelector.generated";
import {
  SearchableSelectInput,
  SelectOption,
} from "./Form/SearchableSelectInput";
import { nodesFromCollectionQuery } from "../helper/nodesFromCollectionQuery";

export const SENSOR_FIRMWARE_NAMES = gql`
  query SensorFirmwareNames {
    sensorFirmwares {
      edges {
        node {
          name
        }
      }
    }
  }
`;

interface Props {
  firmwareName: string | null;
  onChangeFirmwareName: (name: string) => void;
}

export const SensorFirmwareSelector: React.FunctionComponent<Props> = ({
  firmwareName,
  onChangeFirmwareName,
}) => {
  const { data } = useSensorFirmwareNamesQuery();

  if (!data || !data.sensorFirmwares) {
    return null;
  }

  const selectOptions: SelectOption[] = nodesFromCollectionQuery(
    data.sensorFirmwares
  ).map((firmware) => ({
    label: firmware.name,
    value: firmware.name,
  }));

  const selectedValue =
    firmwareName === null ? null : { label: firmwareName, value: firmwareName };

  return (
    <SearchableSelectInput
      value={selectedValue}
      onChange={(option) => onChangeFirmwareName(option.value)}
      options={selectOptions}
    />
  );
};
